import posthog from 'posthog-js';

interface Flag extends Record<string, string> {
    name: string;
}

export const FeatureFlag = {
    QuestionsDrawerUX: {
        name: 'questions-drawer-ux',
        DEFAULT: 'default',
        SPLIT_SCREEN: 'split-screen',
        SCROLL: 'scroll'
    },
    ShowProgressFilters: {
        name: 'show-progress-filters'
    },
    ReleaseFreeTextQuestions: {
        name: 'release-free-text-questions'
    }
} satisfies Record<string, Flag>;

// posthog.featureFlags.override({ [FeatureFlag.QuestionsDrawerUX.name]: FeatureFlag.QuestionsDrawerUX.SCROLL });
posthog.featureFlags.overrideFeatureFlags(false);

export const getFeatureFlag = (flag: keyof typeof FeatureFlag) => {
    const flagName = FeatureFlag[flag].name;
    console.log('requesting flag', { flagName });

    const flagValue = posthog.getFeatureFlag(flagName);
    console.log('got flag value', { flagValue });

    return flagValue;
};
